<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form ref="searchForm" inline>
					<c-form-item type="input" label="用户名" name="login_name"></c-form-item>
					<c-form-item type="input" label="手机号" name="user_manage_mobilephone"></c-form-item>
					<c-form-item type="datetime" date-type="date" label="统计时间" start-name="start_date" end-name="end_date"></c-form-item>
				</c-form>
			</m-search>

			<m-operate>
				<c-button power="b_statistic_platform_user_export" @click="exportData()">导出</c-button>
			</m-operate>
			
			<c-table ref="table">				

				<!-- <c-table-column
					label="用户名"
					name="login_name"
					width="200"
				>
				</c-table-column> -->
				
				<c-table-column
					label="手机号"
					name="user_manage_mobilephone"
					width="130"
				>
					<template v-slot="{data}">
						<span v-if="data.user_manage_mobilephone">{{data.user_manage_mobilephone}}</span>
						<span v-else style="color:#999">--</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="昵称"
					name="nick_name"
				  width="200"
				>
					<template v-slot="{data}">
						<div class="flex-center-cross">
							<c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"> </c-image>
							<span v-if="data.nick_name && data.nick_name!=''">{{data.nick_name}}</span>
							<span v-else>--</span>
						</div>
					</template>
				</c-table-column>
				
				<c-table-column
					label="下单数量"
					name="order_quantity"
					width="100"
					sortable
				>
				</c-table-column>
				
				<c-table-column
					label="下单总额"
					name="order_amount"
					width="110"
                    sortable
				>
					<template v-slot="{data}">
						￥{{data.order_amount}}
					</template>
				</c-table-column>


				<c-table-column
					label="退款数量"
					name="refund_quantity"
					width="100"
                    sortable
				>
				</c-table-column>

				<c-table-column
					label="退款总额"
					name="refund_amount"
					width="110"
                    sortable
				>
					<template v-slot="{data}">
						￥{{data.refund_amount}}
					</template>
				</c-table-column>

				<c-table-column
					label="售后数量"
					name="return_quantity"
					width="100"
                    sortable
				>
				</c-table-column>

				<c-table-column
					label="售后总额"
					name="return_amount"
					width="110"
                    sortable
				>
					<template v-slot="{data}">
						￥{{data.return_amount}}
					</template>
				</c-table-column>

			</c-table>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'm_statistic_platform_user',
		data() {
			return {
				
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/statistic/platform_user/list',
					data
				});
			},
			exportData(){
				var exportData = this.$refs.searchForm.serialize();
				exportData.job_id = 31;
				exportData.create_system = 'OMS';
                exportData.sort_by = this.$refs.table.sortBy||'';
                exportData.sort_type = this.$refs.table.sortType||'';
				this.request({
					url: '/export_job/add',
					data: exportData,
					success: data => {
						this.$message({
		                  	text: '导出任务创建成功，请前往任务中心查看导出进度',
		                  	icon: 'success'
		                });
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	
</style>